export default __webpack_public_path__ + "static/media/warning.503d9b9c.svg";